<template>
  <a-modal
    :visible.sync="TipDialogVisible"
    width="400px"
    class="member-limit-dialog-box "
    :mask-closable="false"
    :footer="null"
    :closable="false"
  >
    <div
      v-if="isNormal"
      class="progress-tip-box"
    >
      <a-progress
        stroke-linecap="square"
        :percent="percent"
        :width="320"
        stroke-color="#42C27E"
      />
      <h3>
        {{ txt }}
      </h3>
    </div>

    <div
      v-else
      class="dialog-tip-box"
    >
      <i class="icon iconfont iconicon-test68" />
      <h2>{{ $t('message["1149"]') }}。</h2>
      <div class="d-tip-con">
        {{ $t('message["1149"]') }}。
      </div>
      <div class="limit-btn-box">
        <a-button
          type="primary"
          @click="TipDialogVisible=false"
        >
          {{ $t('message["401"]') }}
        </a-button>
      </div>
    </div>
  </a-modal>
</template>
<script>
import { mapActions, mapState } from 'vuex'
export default {
  components: {
  },
  props: {
    count: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      TipDialogVisible: false,
      submiting: false,
      typeError: 0,
      txt: this.$t('message["1150"]') + '…',
      percent: 0,
      duration: 3,
      message: '',
      isNormal: true
    }
  },
  computed: {
    ...mapState('organization/cloud', ['']),
    privateCloudTip () {
      return this.$t('message["1151"]').split('|')
    }
  },
  watch: {
    async TipDialogVisible (val) {
      let num = Math.ceil(this.count / 2)
      for (let i = 1; i <= num; i++) {
        if (!this.isNormal) {
          return false
        }
        const chain = await this.loopCloud()
        chain.params({
          cid: this.$route.query.cid,
          page: i
        })
          .onSuccess(res => {
            this.percent = i / num * 100
            if (i === num) {
              this.txt = `${this.privateCloudTip[0]}${this.duration}${this.privateCloudTip[1]}…`
              const interval = setInterval(() => {
                if (this.duration > 1) {
                  this.duration--
                } else {
                  location.reload()
                  clearInterval(interval)
                }
              }, 1000)
            }
          })
          .onNetSuccess(raw => {
            console.log(raw)
            const res = raw.data
            if (res.error) {
              this.message = this.$t('message["1149"]') + '。'
              this.isNormal = false
            }
          })
          .fetch()
      }
    }
  },
  mounted () {
  },
  methods: {
    ...mapActions('organization/cloud', ['loopCloud']),
    changeLimitDialog (b) {
      this.TipDialogVisible = b
    }
  }
}
</script>
<style lang="scss" scoped>
.progress-tip-box::v-deep {
  .ant-progress-bg {
    height: 32px !important;
  }
  h3 {
    text-align: center;
    margin-top: 10px;
  }
}
</style>
